import type { ApiError } from '@festina/life-general-types/life'
import { typeUtils } from '@festina-life/core'

import { ErrorMessage } from './ErrorMessage'
import { isApiError } from './utils'

const isNetworkRelatedError = (error: ApiError) => {
  const networkErrorCodes = [
    408, // Request Timeout
    502, // Bad Gateway
    503, // Service Unavailable
    504, // Gateway Timeout
  ]
  return networkErrorCodes.includes(error.status)
}

type Props = {
  error: unknown
  resetErrorBoundary: () => void
  className?: string
}

export function LifeErrorFallback({
  error,
  resetErrorBoundary,
  className,
}: Props) {
  // For non network related errors, the retry button should be hidden
  const retryAction =
    isApiError(error) && isNetworkRelatedError(error)
      ? resetErrorBoundary
      : undefined

  return (
    <ErrorMessage
      error={typeUtils.toError(error)}
      retryAction={retryAction}
      className={className}
    />
  )
}
